import { useEffect, useRef, useState } from "react";
import { embedUrl } from "@/lib/api";

const HEADER = 130;

export const IgEmbed = ({ username, rows = 1, interactive = false }) => {
  const ref = useRef(null);
  const [w, setW] = useState(0);
  useEffect(() => {
    const ro = new ResizeObserver(([e]) => setW(e.contentRect.width));
    if (ref.current) ro.observe(ref.current);
    return () => ro.disconnect();
  }, []);
  return (
    <div ref={ref} data-testid="ig-embed" className={`overflow-hidden bg-white ${interactive ? "" : "pointer-events-none"}`} style={{ height: w ? HEADER + rows * (w / 3) : 260 }}>
      {w > 0 && (
        <iframe title={`@${username} on Instagram`} src={embedUrl(username)} loading="lazy" scrolling={interactive ? "auto" : "no"}
          className="block w-full border-0" style={{ height: interactive ? HEADER + rows * (w / 3) : HEADER + rows * (w / 3) + 40 }} />
      )}
    </div>
  );
};
